/* ============================================================================
   baesics-product-page.js — Verhalten der Baesics-Zusaetze auf der NATIVEN
   Pipeline-Produktseite (Socken, Broschen, Stickies, Schluesselanhaenger, ...).

   Derzeit genau eine Aufgabe: die mobile Kaufleiste (snippets/baesics-sticky-atc).

   LEITPLANKEN (B11):
     - Fehlt ein Element, passiert nichts. Keine Konsolen-Fehler auf Seiten
       ohne Kaufleiste.
     - Ueberlebt Theme-Editor-Reloads (shopify:section:load / :unload).
     - Raeumt Observer und Listener wieder ab.
     - Kein zweiter Warenkorb-Weg: der Button klickt den echten Kaufbutton.
   ========================================================================== */
(function () {
  'use strict';

  var instances = [];

  /* Der echte Kaufbutton der Produktseite. Pipeline rendert ihn ueber
     snippets/product-add-button-form.liquid; je nach Variante/Version ist es
     ein <button type="submit"> im Produktformular. Mehrere Kandidaten der
     Reihe nach, damit ein Theme-Update das nicht sofort zerlegt. */
  function findRealButton() {
    var selectors = [
      '.product-single form[action*="/cart/add"] [type="submit"]',
      'form[action*="/cart/add"] .add-to-cart',
      'form[action*="/cart/add"] [name="add"]',
      'form[action*="/cart/add"] [type="submit"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  /* Das echte Preis-Element in der Kaufspalte. */
  function findRealPrice() {
    return document.querySelector('.product-single .product__price');
  }

  function init(root) {
    var bar = (root || document).querySelector('[data-bae-sticky]');
    if (!bar) return;

    var realBtn = findRealButton();
    if (!realBtn) {
      /* Ohne echten Kaufbutton haette die Leiste nichts zu klicken. Lieber
         gar nicht zeigen als einen toten Button anbieten. */
      bar.remove();
      return;
    }

    var stickyBtn = bar.querySelector('[data-bae-sticky-btn]');
    var stickyPrice = bar.querySelector('[data-bae-sticky-price]');
    var realPrice = findRealPrice();
    var cleanups = [];

    /* Polster am Seitenende: die Leiste ist position:fixed und wuerde sonst die
       letzten ~65px verdecken (auf der letzten Bildschirmseite also Teile des
       Fusses). Die Klasse kommt erst hier, wenn die Leiste wirklich existiert
       UND ein echter Kaufbutton gefunden wurde — Seiten ohne Leiste bekommen
       keinen Leerraum.
       Kein bar.hidden = false mehr: das war wirkungslos, weil die Autoren-Regel
       .bae-sticky{display:flex} die UA-Regel [hidden]{display:none} schlaegt.
       Sichtbarkeit haengt allein an der Klasse is-on (CSS: visibility+transform). */
    document.body.classList.add('bae-has-sticky');
    cleanups.push(function () { document.body.classList.remove('bae-has-sticky'); });

    /* --- Sichtbarkeit: Leiste zeigen, sobald der echte Button weg ist ------ */
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            /* Nur einblenden, wenn der echte Button OBERHALB des Bildschirms
               liegt (also weggescrollt), nicht wenn er noch darunter wartet.
               Sonst klebt die Leiste schon beim Seitenaufruf am Rand. */
            var scrolledPast = entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-on', !entry.isIntersecting && scrolledPast);
          });
        },
        { threshold: 0 }
      );
      io.observe(realBtn);
      cleanups.push(function () { io.disconnect(); });
    } else {
      /* Fallback ohne IntersectionObserver: dann eben immer sichtbar. */
      bar.classList.add('is-on');
    }

    /* --- Preis spiegeln ---------------------------------------------------
       Kein Varianten-Event abonnieren: dieses Theme hat kein
       theme:variant:change (nur theme:cart:change fuer den Warenkorb).
       Stattdessen das echte Preis-Element beobachten — das aendert Pipeline
       ohnehin bei jedem Variantenwechsel. Robust gegen Theme-Interna. */
    var mo = null;
    if (realPrice && stickyPrice && 'MutationObserver' in window) {
      var syncPrice = function () {
        var txt = (realPrice.textContent || '').trim();
        if (txt) stickyPrice.textContent = txt;
      };
      syncPrice();
      mo = new MutationObserver(syncPrice);
      mo.observe(realPrice, { childList: true, subtree: true, characterData: true });
      cleanups.push(function () { mo.disconnect(); });
    }

    /* --- Ausverkauft-Zustand UND Beschriftung spiegeln ----------------------
       Nicht nur disabled: Pipeline tauscht auch den TEXT des echten Buttons
       ('In den Warenkorb' <-> 'Ausverkauft', products.product.sold_out). Ohne
       Text-Spiegelung haette die Leiste bei einer ausverkauften Variante weiter
       'In den Warenkorb' angeboten, waehrend der echte Button daneben
       'Ausverkauft' sagt — zwei Buttons, die sich widersprechen.
       Der echte Button enthaelt teils Preis/Icons; nur den reinen Text nehmen
       und auf eine Zeile normalisieren. */
    var moBtn = null;
    if (stickyBtn && 'MutationObserver' in window) {
      var syncState = function () {
        var off = realBtn.disabled === true || realBtn.getAttribute('aria-disabled') === 'true';
        stickyBtn.disabled = off;
        var label = (realBtn.textContent || '').replace(/\s+/g, ' ').trim();
        /* Pipeline haengt den Preis ans Label: "In den Warenkorb • 14,95 €".
           Die Leiste zeigt den Preis bereits links daneben — Zusatz abschneiden,
           sonst steht er doppelt.
           Am Trennzeichen splitten, NICHT am Preis: welches Zeichen das Theme
           nutzt, ist Einstellungssache. Gemessen ist es • (U+2022); · (U+00B7),
           | und die Striche sind als Varianten mit abgedeckt. */
        var cut = label.search(/\s[•·|–—-]\s/);
        if (cut > 0) label = label.slice(0, cut).trim();
        if (label) stickyBtn.textContent = label;
      };
      syncState();
      moBtn = new MutationObserver(syncState);
      /* childList/characterData mit: der Text aendert sich, nicht nur Attribute. */
      moBtn.observe(realBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
        characterData: true
      });
      cleanups.push(function () { moBtn.disconnect(); });
    }

    /* --- Klick: den echten Button druecken --------------------------------- */
    var onClick = function () {
      if (stickyBtn.disabled) return;
      realBtn.click();
    };
    if (stickyBtn) {
      stickyBtn.addEventListener('click', onClick);
      cleanups.push(function () { stickyBtn.removeEventListener('click', onClick); });
    }

    instances.push({ bar: bar, cleanups: cleanups });
  }

  function destroy(root) {
    instances = instances.filter(function (inst) {
      if (root && !root.contains(inst.bar)) return true;
      inst.cleanups.forEach(function (fn) { fn(); });
      return false;
    });
  }

  function boot() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme-Editor: Abschnitt neu geladen -> neu verdrahten. */
  document.addEventListener('shopify:section:load', function (e) {
    destroy(e.target);
    init(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroy(e.target);
  });
})();
